module.exports = __webpack_public_path__ + "img/Group 1162.59b52db3.svg";